export default __webpack_public_path__ + "static/media/dub-config.02e7d0d2.webp";